import { Injectable } from '@angular/core';
import { ServiceBase } from 'app/shared/serviceBase';
import { AuthenticationService } from 'app/shared/services/authentication-service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuditTemplateDetailsModel } from '../models/audit-template-details.model';
import { AuditTemplateAddModel } from '../models/audit-template-add.model';
import { AuditTemplateUpdateModel } from '../models/audit-template-update.model';
import { AuditCategoryModel } from '../models/audit-category.model';
import { ModuleModel } from '../../module/models/module.model';
import { AuditTemplateModuleDetailsModel } from '../models/audit-template-module-details.model';
import { AuditModuleReorderModel } from '../models/audit-module-reorder.model';

@Injectable()
export class AuditTemplateService extends ServiceBase {
    private commonUrl: string = this.url + '/AuditTemplate/';
    constructor(
        private _http: HttpClient,
        private _authentication: AuthenticationService
    ) {
        super();
    }

    create(model: AuditTemplateAddModel): Observable<string> {
        const completeUrl: string = this.commonUrl;
        return this._http
            .post<string>(completeUrl, model).pipe(
                catchError(this.handleError));
    }

    update(model: AuditTemplateUpdateModel): Observable<Response> {
        const completeUrl: string = this.commonUrl;
        return this._http
            .put(completeUrl, model).pipe(
                map((response: Response) => response),
                catchError(this.handleError));
    }

    getAll(): Observable<AuditTemplateDetailsModel[]> {
        const completeUrl: string = this.commonUrl;
        return this._http
            .get<AuditTemplateDetailsModel[]>(completeUrl)
            .pipe(catchError(this.handleError));
    }

    getAllForCompany(companyId: string): Observable<AuditTemplateDetailsModel[]> {
        const completeUrl: string = this.commonUrl + 'company/' + companyId;
        return this._http
            .get<AuditTemplateDetailsModel[]>(completeUrl)
            .pipe(catchError(this.handleError));
    }

    get(id: string): Observable<AuditTemplateDetailsModel> {
        const completeUrl: string = this.commonUrl + id;
        return this._http
            .get<AuditTemplateDetailsModel>(completeUrl).pipe(
                catchError(this.handleError));
    }

    getAuditCategories(): Observable<AuditCategoryModel[]> {
        const completeUrl: string = this.commonUrl + 'categories';
        return this._http
            .get<AuditCategoryModel[]>(completeUrl)
            .pipe(catchError(this.handleError));
    }

    getModules(): Observable<ModuleModel[]> {
        const completeUrl: string = this.commonUrl + 'modules';
        return this._http
            .get<ModuleModel[]>(completeUrl)
            .pipe(catchError(this.handleError));
    }

    getAuditTemplateModules(auditId: string): Observable<AuditTemplateModuleDetailsModel[]> {
        const completeUrl: string = this.commonUrl + 'audit-template-modules/' + auditId;
        return this._http
            .get<AuditTemplateModuleDetailsModel[]>(completeUrl)
            .pipe(catchError(this.handleError));
    }

    addModuleToAuditTemplate(model: AuditTemplateModuleDetailsModel): Observable<string> {
        const completeUrl: string = this.commonUrl + 'add-module';
        return this._http
            .post<string>(completeUrl, model).pipe(
                catchError(this.handleError));
    }

    deleteAuditTemplateModule(auditTemplateId: string, moduleId: string): Observable<Response> {
        const completeUrl: string = this.commonUrl + 'delete-audit-template-module/' + auditTemplateId + '/' + moduleId;
        return this._http.delete(completeUrl).pipe(
            map((response: Response) => response),
            catchError(this.handleError));
    }

    reorderModuleQuestionBank(model: AuditModuleReorderModel): Observable<string> {
        const completeUrl: string = this.commonUrl + 'audit-module-reorder';
        return this._http
            .post<string>(completeUrl, model).pipe(
                catchError(this.handleError));
    }

    
}
